import { connect } from 'react-redux';
import KWHPIE from './KWHPIE';

import { getAnnualResults } from '../../selectors';
import { setSystemProduction } from '../../actions';
import { selectTotalkWh } from '../../../../../common/utility/selectors';


const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    doughnutSlider: state.settings.doughnutSlider,
    annualKWH: state.utility.annualKWH,
    annualMonth: state.settings.annualMonth,
    totalkWhs: selectTotalkWh(state),
});

const combinedActions = {
    setSystemProduction,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(KWHPIE);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/KWHPIE/index.js